module.exports = __webpack_public_path__ + "img/curriculum_des_4.d177917c.jpg";